import React from "react";
import CustomButton from "/components/core/ButtonDefault";
import FB from "/assets/img/sso/fb.svg";
import GG from "/assets/img/sso/google.svg";
import Apple from "/assets/img/sso/apple.svg";
import Discord from "/assets/img/sso/discord.svg";
import Instagram from "/assets/img/sso/insta.svg";
import Telegram from "/assets/img/sso/telegram.svg";
import X from "/assets/img/sso/x.svg";
import { useTranslation } from "react-i18next";

export const ssoLabels = [
  // {
  //   name: "facebook",
  //   label: "Facebook",
  //   icon: <FB />,
  // },
  // {
  //   name: "instagram",
  //   label: "Instagram",
  //   icon: <Instagram />,
  // },
  // {
  //   name: "x",
  //   label: "x (Twitter)",
  //   icon: <X />,
  // },
  {
    name: "google",
    label: "Google",
    icon: <GG />,
  },
  {
    name: "discord",
    label: "Discord",
    icon: <Discord />,
  },
  // {
  //   name: "apple",
  //   label: "Apple",
  //   icon: <Apple />,
  // },
  // {
  //   name: "telegram",
  //   label: "Telegram",
  //   icon: <Telegram />,
  // },
];

export default function SocialButtonsGrid({
  onSelect,
  selected,
  displayContext = "registration",
  children,
  disabled,
}) {
  const { t } = useTranslation();
  const isContextRegistration = displayContext === "registration";
  return (
    <>
      <div className="or df ai-c">
        {isContextRegistration
          ? t("labels.registerWith")
          : t("labels.signInWith")}
      </div>
      <div className="via_soc df jc-c fw gap-16">
        {ssoLabels.map(({ name, label, icon }) => (
          <CustomButton
            def={14}
            key={name}
            disabled={disabled}
            classname={`def sso ${selected === name ? "gradient" : "tr"}`}
            onClick={() => onSelect(name)}
          >
            {icon}
            <span className="txt">{label}</span>
          </CustomButton>
        ))}
      </div>
      {children}
    </>
  );
}
